import { ApiResponsePageCouncilDTO, PageCouncilDTO } from "@/gen/api"
import { GetCouncilsStatusEnum } from "@/gen/api/backend/council-api"
import { councilApi } from "@/lib/api"
import { useInfiniteQuery } from "@tanstack/react-query"

const councilPageApi = async ({
  pageParam,
  search,
  status,
}: {
  pageParam?: unknown
  search?: string
  status?: GetCouncilsStatusEnum
}): Promise<PageCouncilDTO> => {
  const page = (pageParam as number) || 0
  const response = await councilApi.getCouncils(page, 20, search, status)
  return (response.data as ApiResponsePageCouncilDTO).data as PageCouncilDTO
}

export const useGetCouncilPage = (search?: string, status?: GetCouncilsStatusEnum) => {
  return useInfiniteQuery<PageCouncilDTO>({
    queryKey: ["councils", search, status],
    queryFn: ({ pageParam }) =>
      councilPageApi({
        pageParam,
        ...(search !== undefined ? { search } : {}),
        ...(status !== undefined ? { status } : {}),
      }),
    initialPageParam: 0,
    getNextPageParam: (lastPage) => {
      return lastPage.last ? undefined : (lastPage.number ?? 0) + 1
    },
  })
}
